import { useState } from "react";
import { hueOf, initialsOf } from "../cockpit-ui";

// Photo de l'expéditeur dans un groupe (à gauche de la dernière bulle d'une série).
// Initiales en fond (teinte stable) ; la photo se superpose et retombe sur les
// initiales si l'avatar n'existe pas (404/501 → onError) — données du roster (#112).
export function SenderAvatar({
  src,
  label,
  size = 26,
}: {
  src: string | null;
  label: string;
  /** Diamètre en px (défaut 26 : la bulle de groupe ; ~56 sur une fiche). */
  size?: number;
}) {
  const [broken, setBroken] = useState(false);
  const hue = hueOf(label);
  return (
    <div
      className="msg-avatar"
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.42),
        background: `linear-gradient(135deg, hsl(${hue} 42% 40%), hsl(${hue} 48% 27%))`,
      }}
    >
      {initialsOf(label)}
      {src && !broken && <img src={src} alt="" onError={() => setBroken(true)} />}
    </div>
  );
}
